module.exports = "/_next/static/images/d4db0ae77dd5c632f2bb9e042faf3648-mgm-md-2x.jpg.webp";